import React, { useRef } from 'react';

export default function CategoryTabs({ categories, activeCategory, onSelect }) {
  const scrollRef = useRef(null);

  const tabs = [{ id: 'all', name: '전체' }, ...categories];

  const handleSelect = (id, idx) => {
    onSelect(id);
    const container = scrollRef.current;
    if (container) {
      const tab = container.children[idx];
      if (tab) {
        const containerRect = container.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const scrollLeft =
          container.scrollLeft +
          tabRect.left -
          containerRect.left -
          containerRect.width / 2 +
          tabRect.width / 2;
        container.scrollTo({ left: scrollLeft, behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="category-tabs-wrap">
      <div ref={scrollRef} className="category-tabs">
        {tabs.map((tab, idx) => (
          <button
            key={tab.id}
            className={`chip ${activeCategory === tab.id ? 'chip-active' : ''}`}
            onClick={() => handleSelect(tab.id, idx)}
            style={{ flexShrink: 0 }}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  );
}
